import { useIdleLogout } from "./useIdleLogout";

export default function IdleLogout() {
  useIdleLogout();
  return null;
}
